import axios from "axios"
import { convertPermission } from "permissionUtils"
import React, { useState } from "react"
import { Form, Modal, ModalBody, ModalHeader } from "reactstrap"
const UpdateOutsidePagesLinksModal = ({
  projectPagesLinkToggle,
  projectPagesLinkType,
  ProjectID,
  setAuth,
}) => {
  const [Dmodal, setDmodal] = useState(true)
  const Dtoggle = () => {
    setDmodal(!Dmodal)
    projectPagesLinkToggle()
  }

  const updatePageLinkHandler = e => {
    e.preventDefault()
    // console.log("projectPagesLinkType", projectPagesLinkType)

    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ProjectID: ProjectID,
      Type: projectPagesLinkType,
    }

    axios
      .post(process.env.REACT_APP_API_URL + "api/uuchannel.php", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        console.log("res", res)
      })
      .catch(err => console.log("error------>", err))

    projectPagesLinkToggle()
  }
  return (
    /**************delete pop up***************/
    <Modal isOpen={Dmodal} toggle={Dtoggle}>
      <ModalHeader>
        {`Update ${
          projectPagesLinkType === "M" ? "Missing Data" : "Tickets"
        } Page link`}
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={Dtoggle}
        />
      </ModalHeader>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <Form onSubmit={updatePageLinkHandler}>
            <p className="text-muted font-size-16 mb-4">
              Are you sure you want to update the page link?
            </p>

            <div className="hstack gap-2 justify-content-center mb-0">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={Dtoggle}
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Confirm
              </button>
            </div>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  )
}

export default UpdateOutsidePagesLinksModal
